import React, { forwardRef } from "react";
import DataTableMultiSelectFilter from "./DataTableMultiSelectFilter";
import ModuleStatusLabel from "../labels/ModuleStatusLabel";

/** @param {object} option Filter option whose `value` is a module status. */
function renderModuleStatusLabel(option) {
    return (
        <ModuleStatusLabel value={option.value} />
    );
}

/**
 * DataTable toolbar Status filter. Kept as its own component so Status-specific design changes
 * land here without affecting other multi-select filters (e.g. Term).
 * Accepts every `DataTableMultiSelectFilter` prop; `placeholder` defaults to "Status" and
 * `renderLabel` to a `ModuleStatusLabel` pill.
 */
const DataTableStatusFilter = forwardRef(function DataTableStatusFilter(
    { placeholder = "Status", renderLabel = renderModuleStatusLabel, ...props },
    ref
) {
    return (
        <DataTableMultiSelectFilter ref={ref} placeholder={placeholder} renderLabel={renderLabel} {...props} />
    );
});

DataTableStatusFilter.displayName = "DataTableStatusFilter";

export default DataTableStatusFilter;
